"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
const SessionLogout = ({ children }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    let timer;
    const handleSessionTimeOut = () => {
        timer = setTimeout(() => {
            resetTimer();
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            logOut();
        }, 15 * 60 * 1000);
    };
    const resetTimer = () => {
        if (timer)
            clearTimeout(timer);
    };
    (0, react_1.useEffect)(() => {
        resetTimer();
        handleSessionTimeOut();
    });
    Object.values(events).forEach((item) => {
        window.addEventListener(item, () => {
            resetTimer();
            handleSessionTimeOut();
        });
    });
    const logOut = () => {
        navigate('/auth/logout');
    };
    return children;
};
exports.default = SessionLogout;
